module.exports = __webpack_public_path__ + "static/media/partner-3.e999ee31.png";